import React from 'react';
import { formatCountyName } from '../utils/dataTransform';

const MayorListItem: React.FunctionComponent<any> = ({mayor, onClick}) => {

  const getColor = (mayor: any) => {
    if (mayor.isLGI) {
      if (mayor.pilot_program === "Yes") {
        return "bg-main-orange";
      }
      return "bg-light-orange";
    } else if (mayor.isCGI) {
      if (mayor.pilot_program === "Yes") {
        return "bg-main-green";
      }
      return "bg-light-green";
    } else {
      if (mayor.pilot_program === "Yes" || mayor.yes === "Yes") {
        return "bg-main-purple";
      }
      return "bg-light-purple";
    }
  }

  return (
    <div className="flex items-center border-4 border-black mb-2.5 md:mb-6 p-0.5 cursor-pointer" onClick={() => onClick(mayor)}>
      <div className={`w-1/5 min-h-custom ${getColor(mayor)}`}></div>
      <div className="flex-1 pl-6 font-bold">
          <span className="text-xl block">{mayor.isLGI ? mayor.district : (mayor.city || formatCountyName(mayor.county, mayor.state))}, {mayor.state} </span>
          <span className="text-sm block">{mayor.mayors_name || mayor.county_officials_name || mayor.legislators_name}</span>
      </div>
      <button className="text-3xl mr-3">&#9656;</button>
    </div>
  )
}

export default MayorListItem;